import { useTranslation } from 'react-i18next'
import { EmptyState } from '@/ds'
import { useStay } from '../../stay/StayProvider'

/** Sin conexión y sin reserva en caché (DESIGN.md §4 estados; inventario D18). */
export function Offline() {
  const { t } = useTranslation()
  const { reload } = useStay()
  return (
    <main className="page">
      <EmptyState icon="wifi-off" headingLevel={1} title={t('v2.ds.offline')} actionLabel={t('v2.comun.reintentar')} onAction={reload} />
    </main>
  )
}
